import { ThemeEvents, CartUpdatedEvent } from '@theme/events';

const shopRoot = window.Shopify?.routes?.root || '/';
const cartAddUrl = `${shopRoot}cart/add.js`;
const cartJsonUrl = `${shopRoot}cart.js`;
const recommendationsUrl = `${shopRoot}recommendations/products.json`;
const MAX_UPSELLS = 3;
const FAUCET_FALLBACK_HANDLES = [
  'nerylux-sm-nouvet-single-handle-pull-down-kitchen-faucet-in-chrome-1',
  'nerylux-sm-chalet-single-handle-pull-down-kitchen-faucet-in-matte-black-1',
  'nerylux-sm-chalet-single-handle-pull-down-kitchen-faucet-in-brushed-nickel-1',
];
const SINK_FALLBACK_HANDLES = [
  'nerylux-sm-rivage-36-x-21-stainless-steel-single-basin-farmhouse-kitchen-sink-with-apron-1',
  'nerylux-sm-toulouse-31-x-18-stainless-steel-single-basin-under-mount-kitchen-sink',
  'nerylux-sm-elegance-33-x-20-single-basin-fireclay-workstation-kitchen-sink-in-glossy-white-sm-ks3801gw',
];
let recommendationRequest = 0;

function injectNeryluxCartStyles() {
  if (document.getElementById('NeryluxCartUpsellStyles')) return;

  const style = document.createElement('style');
  style.id = 'NeryluxCartUpsellStyles';
  style.textContent = `
    .ny-cart-upsells{margin:14px 0;padding:16px;border:1px solid #dbe3e2;background:#f4f7f6;color:#111819}
    .ny-cart-upsells__head{display:flex;align-items:end;justify-content:space-between;gap:12px;margin-bottom:12px}
    .ny-cart-upsells__eyebrow{display:block;margin-bottom:4px;color:#216f78;font-size:9px;font-weight:750;letter-spacing:.13em;text-transform:uppercase}
    .ny-cart-upsells h2{margin:0;font-family:inherit;font-size:16px;font-weight:600;line-height:1.3;letter-spacing:-.02em}
    .ny-cart-upsells__list{display:grid;gap:8px}
    .ny-cart-upsells__item{display:grid;grid-template-columns:68px minmax(0,1fr) auto;align-items:center;gap:10px;padding:6px;background:#fff}
    .ny-cart-upsells__media{display:block;width:68px;height:68px;background:#fff}
    .ny-cart-upsells__media img{width:100%;height:100%;object-fit:contain;display:block}
    .ny-cart-upsells__copy{min-width:0}
    .ny-cart-upsells__copy a{display:-webkit-box;overflow:hidden;color:#111819;font-size:12px;font-weight:650;line-height:1.3;text-decoration:none;-webkit-box-orient:vertical;-webkit-line-clamp:2}
    .ny-cart-upsells__price{display:block;margin-top:4px;font-size:12px;font-weight:700}
    .ny-cart-upsells__action{min-height:36px;padding:0 10px;border:1px solid #111819;background:#111819;color:#fff;font-family:inherit;font-size:11px;font-weight:600;line-height:1.2;text-decoration:none;display:flex;align-items:center;justify-content:center;cursor:pointer}
    .ny-cart-upsells__action--choose{background:#fff;color:#111819}
    .ny-cart-upsells__action:disabled{opacity:.55;cursor:wait}
    .ny-empty-guidance{display:flex;flex-wrap:wrap;justify-content:center;gap:8px;margin-top:16px}
    .ny-empty-guidance a{min-height:42px;padding:0 16px;border:1px solid #111819;color:#111819;text-decoration:none;display:inline-flex;align-items:center;justify-content:center;font-size:12px;font-weight:700}
    .ny-empty-guidance a:first-child{background:#111819;color:#fff}
    cart-component .ny-cart-upsells{grid-column:1/-1;margin:0 0 20px}
    cart-component .ny-cart-upsells__list{grid-template-columns:repeat(3,minmax(0,1fr))}
    cart-component .ny-cart-upsells__item{grid-template-columns:76px minmax(0,1fr);align-items:start}
    cart-component .ny-cart-upsells__media{width:76px;height:76px;grid-row:1/3}
    cart-component .ny-cart-upsells__action{grid-column:2;width:max-content;margin-top:4px}
    @media(max-width:749px){
      .ny-cart-upsells{padding:13px}
      .ny-cart-upsells__list{display:flex;gap:8px;overflow-x:auto;scroll-snap-type:x mandatory;scrollbar-width:none}
      .ny-cart-upsells__list::-webkit-scrollbar{display:none}
      .ny-cart-upsells__item{flex:0 0 min(86%,310px);scroll-snap-align:start}
      cart-component .ny-cart-upsells__list{display:flex}
      cart-component .ny-cart-upsells__item{grid-template-columns:68px minmax(0,1fr) auto;align-items:center}
      cart-component .ny-cart-upsells__media{width:68px;height:68px;grid-row:auto}
      cart-component .ny-cart-upsells__action{grid-column:auto;margin-top:0}
    }
  `;
  style.textContent += "\n    cart-drawer .cart-drawer__body{flex:1 1 auto;min-height:0;overflow-y:auto;overscroll-behavior:contain}\n    cart-drawer .cart-drawer__header,cart-drawer .cart-drawer__footer{flex:0 0 auto}\n    cart-drawer .ny-cart-upsells{padding:12px;margin:16px 0 8px;background:#faf8f3;border-color:#ded7cb}\n    cart-drawer .ny-cart-upsells h2{font-size:16px!important;line-height:1.3!important;font-weight:600!important;letter-spacing:0;margin:0}\n    cart-drawer .ny-cart-upsells__eyebrow{font-size:9px;color:#70634b}\n    cart-drawer .ny-cart-upsells__list{display:flex;gap:8px;overflow-x:auto;scroll-snap-type:x mandatory;scrollbar-width:thin;padding-bottom:6px}\n    cart-drawer .ny-cart-upsells__item{flex:0 0 94%;min-width:0;grid-template-columns:48px minmax(0,1fr) auto;gap:8px;scroll-snap-align:start;padding:6px}\n    cart-drawer .ny-cart-upsells__media{width:48px;height:48px}\n    cart-drawer .ny-cart-upsells__copy a{font-size:11px;font-weight:500;line-height:1.35}\n    cart-drawer .ny-cart-upsells__price{font-size:12px;font-weight:600}\n    cart-drawer .ny-cart-upsells__action{font-size:11px;min-height:40px;padding:0 8px;background:#252922;border-color:#252922}\n";
  document.head.appendChild(style);
}

function formatMoney(cents) {
  const currency = window.Shopify?.currency?.active || 'EUR';
  return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
    style: 'currency',
    currency,
  }).format((Number(cents) || 0) / 100);
}

function updateCartCount(count) {
  document.querySelectorAll('.ny-cart-count').forEach((bubble) => {
    bubble.textContent = count;
    bubble.hidden = count < 1;
  });
}

async function getCart() {
  const response = await fetch(cartJsonUrl, { headers: { Accept: 'application/json' } });
  if (!response.ok) throw new Error('Impossible de charger le panier.');
  return response.json();
}

function installEmptyCartGuidance(cart) {
  if (cart.item_count > 0) {
    document.querySelectorAll('.ny-empty-guidance').forEach((node) => node.remove());
    return;
  }

  document.querySelectorAll('.cart__empty, .cart-drawer__empty').forEach((emptyState) => {
    if (emptyState.querySelector('.ny-empty-guidance')) return;
    const guidance = document.createElement('nav');
    guidance.className = 'ny-empty-guidance';
    guidance.setAttribute('aria-label', 'Découvrir nos collections');

    const sinks = document.createElement('a');
    sinks.href = `${shopRoot}search?q=${encodeURIComponent('évier')}&type=product`;
    sinks.textContent = 'Découvrir les éviers';

    const faucets = document.createElement('a');
    faucets.href = `${shopRoot}collections/robinetterie`;
    faucets.textContent = 'Découvrir la robinetterie';

    guidance.append(sinks, faucets);
    emptyState.appendChild(guidance);
  });
}

function getUpsellMounts() {
  const mounts = [];
  const drawer = document.querySelector('cart-drawer');
  const drawerBody = drawer?.querySelector('.cart-drawer__body');
  if (drawerBody) mounts.push({ context: 'drawer', parent: drawerBody, before: null });

  const cartComponent = document.querySelector('cart-component');
  const cartFooter = cartComponent?.querySelector('.cart__footer');
  if (cartFooter) mounts.push({ context: 'main', parent: cartFooter.parentElement, before: cartFooter });
  return mounts;
}

function createProductCard(product) {
  const card = document.createElement('article');
  card.className = 'ny-cart-upsells__item';
  card.dataset.productId = product.id;

  const mediaLink = document.createElement('a');
  mediaLink.className = 'ny-cart-upsells__media';
  mediaLink.href = product.url;

  const image = document.createElement('img');
  image.src = product.featured_image;
  image.alt = product.title;
  image.width = 160;
  image.height = 160;
  image.loading = 'lazy';
  mediaLink.appendChild(image);

  const copy = document.createElement('div');
  copy.className = 'ny-cart-upsells__copy';
  const title = document.createElement('a');
  title.href = product.url;
  title.textContent = product.title;
  const price = document.createElement('span');
  price.className = 'ny-cart-upsells__price';
  price.textContent = formatMoney(product.price);
  copy.append(title, price);

  const availableVariants = (product.variants || []).filter((variant) => variant.available);
  let action;
  if (product.variants?.length === 1 && availableVariants.length === 1) {
    action = document.createElement('form');
    action.method = 'post';
    action.action = `${shopRoot}cart/add`;
    action.dataset.nyAjaxCart = '';
    action.dataset.nyQuickAdd = '';

    const variantId = document.createElement('input');
    variantId.type = 'hidden';
    variantId.name = 'id';
    variantId.value = availableVariants[0].id;
    const quantity = document.createElement('input');
    quantity.type = 'hidden';
    quantity.name = 'quantity';
    quantity.value = '1';
    const button = document.createElement('button');
    button.type = 'submit';
    button.className = 'ny-cart-upsells__action';
    button.textContent = 'Ajouter +';
    button.setAttribute('aria-label', `Ajouter ${product.title} au panier`);
    action.append(variantId, quantity, button);
  } else {
    action = document.createElement('a');
    action.className = 'ny-cart-upsells__action ny-cart-upsells__action--choose';
    action.href = product.url;
    action.textContent = 'Choisir';
  }

  card.append(mediaLink, copy, action);
  return card;
}

function cartProductKind(product) {
  const text = [product.handle, product.product_title, product.title, product.product_type, product.type].filter(Boolean).join(' ');
  if (/robinet|mitigeur|faucet|mixer/i.test(text) && !/deck|plaque|accessoire/i.test(text)) return 'faucet';
  if (/évier|evier|sink/i.test(text) && !/drain|bonde|accessoire/i.test(text)) return 'sink';
  return '';
}
function cartUpsellTarget(cart) {
  const kinds = new Set(cart.items.map(cartProductKind));
  if (kinds.has('sink') && kinds.has('faucet')) return '';
  return kinds.has('sink') ? 'faucet' : kinds.has('faucet') ? 'sink' : '';
}
function renderUpsells(products, target = '') {
  getUpsellMounts().forEach(({ context, parent, before }) => {
    parent.querySelector(`.ny-cart-upsells[data-context="${context}"]`)?.remove();
    if (!products.length) return;

    const section = document.createElement('section');
    section.className = 'ny-cart-upsells';
    section.dataset.context = context;
    section.setAttribute('aria-labelledby', `NyCartUpsellsTitle-${context}`);

    const header = document.createElement('header');
    header.className = 'ny-cart-upsells__head';
    const headingGroup = document.createElement('div');
    const eyebrow = document.createElement('span');
    eyebrow.className = 'ny-cart-upsells__eyebrow';
    eyebrow.textContent = 'Avec votre sélection';
    const heading = document.createElement('h2');
    heading.id = `NyCartUpsellsTitle-${context}`;
    heading.textContent = target === 'faucet' ? 'Un robinet pour compléter votre cuisine' : 'Et l’évier qui l’accompagne ?';
    headingGroup.append(eyebrow, heading);
    header.appendChild(headingGroup);

    const list = document.createElement('div');
    list.className = 'ny-cart-upsells__list';
    products.forEach((product) => list.appendChild(createProductCard(product)));
    section.append(header, list);
    parent.insertBefore(section, before);
  });
}

async function loadFallbackProducts(cart, excludedProductIds, selectedIds) {
  const target = cartUpsellTarget(cart);
  const handles = target === 'faucet' ? FAUCET_FALLBACK_HANDLES : SINK_FALLBACK_HANDLES;
  const fallbackProducts = [];

  for (const handle of handles) {
    if (fallbackProducts.length >= MAX_UPSELLS) break;
    try {
      const response = await fetch(`${shopRoot}products/${handle}.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) continue;
      const product = await response.json();
      const productId = Number(product.id);
      if (
        excludedProductIds.has(productId) ||
        selectedIds.has(productId) ||
        !product.available ||
        !product.featured_image ||
        Number(product.price) <= 0
      ) continue;
      selectedIds.add(productId);
      fallbackProducts.push(product);
    } catch (error) {
      console.warn('Nerylux curated recommendation unavailable', error);
    }
  }

  return fallbackProducts;
}

async function loadCartUpsells(cart) {
  const requestId = ++recommendationRequest;
  const target = cartUpsellTarget(cart);
  if (!cart.item_count || !target) {
    renderUpsells([]);
    return;
  }

  const cartProductIds = new Set(cart.items.map((item) => Number(item.product_id)));
  const selectedIds = new Set();
  const selectedProducts = [];

  for (const item of cart.items) {
    if (selectedProducts.length >= MAX_UPSELLS) break;
    const url = new URL(recommendationsUrl, window.location.origin);
    url.searchParams.set('product_id', item.product_id);
    url.searchParams.set('limit', '10');
    url.searchParams.set('intent', 'complementary');

    try {
      const response = await fetch(url.toString(), { headers: { Accept: 'application/json' } });
      if (!response.ok) continue;
      const payload = await response.json();
      for (const product of payload.products || []) {
        const productId = Number(product.id);
        if (
          selectedProducts.length >= MAX_UPSELLS ||
          cartProductKind(product) !== target ||
          cartProductIds.has(productId) ||
          selectedIds.has(productId) ||
          !product.available ||
          !product.featured_image ||
          Number(product.price) <= 0
        ) continue;
        selectedIds.add(productId);
        selectedProducts.push(product);
      }
    } catch (error) {
      console.warn('Nerylux complementary recommendations unavailable', error);
    }
  }

  if (selectedProducts.length < MAX_UPSELLS) {
    const fallbackProducts = await loadFallbackProducts(cart, cartProductIds, selectedIds);
    for (const product of fallbackProducts) {
      if (selectedProducts.length >= MAX_UPSELLS) break;
      selectedProducts.push(product);
    }
  }

  if (requestId === recommendationRequest) renderUpsells(selectedProducts, target);
}

async function refreshCartExperience(providedCart) {
  injectNeryluxCartStyles();
  try {
    const cart = providedCart || await getCart();
    updateCartCount(cart.item_count);
    installEmptyCartGuidance(cart);
    await loadCartUpsells(cart);
  } catch (error) {
    console.warn('Nerylux cart refresh unavailable', error);
  }
}

function getSectionIds() {
  const ids = new Set();
  const drawer = document.querySelector('cart-drawer');
  if (drawer?.dataset.sectionId) ids.add(drawer.dataset.sectionId);

  const cartSection = document.querySelector('cart-component')?.closest('[id^="shopify-section-"]');
  if (cartSection) ids.add(cartSection.id.replace('shopify-section-', ''));
  return [...ids];
}

function renderReturnedCartSection(sections) {
  const currentSection = document.querySelector('cart-component')?.closest('[id^="shopify-section-"]');
  if (!currentSection) return;
  const sectionId = currentSection.id.replace('shopify-section-', '');
  const html = sections?.[sectionId];
  if (!html) return;
  const parsed = new DOMParser().parseFromString(html, 'text/html');
  const replacement = parsed.getElementById(currentSection.id);
  if (replacement) currentSection.replaceWith(replacement);
}

function setFormStatus(form, message, isError = false) {
  const scope = form.closest('.ny-complement__card, .ny-pdp, .ny-cart-upsells') || form.parentElement;
  const status = scope?.querySelector('[data-ny-cart-status]');
  if (!status) return;
  status.textContent = message;
  status.classList.toggle('is-error', isError);
}

async function handleAjaxCartSubmit(form) {
  if (form.dataset.nySubmitting === 'true') return;
  form.dataset.nySubmitting = 'true';
  const button = form.querySelector('[type="submit"]');
  const labelNode = button?.querySelector('[data-atc-label]');
  const originalLabel = labelNode?.textContent || button?.textContent;
  if (button) {
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    if (form.matches('.ny-product-form')) labelNode?.replaceChildren('Ajout…');
  }
  setFormStatus(form, 'Ajout au panier…');

  try {
    const body = new FormData(form);
    const sectionIds = getSectionIds();
    if (sectionIds.length) {
      body.set('sections', sectionIds.join(','));
      body.set('sections_url', window.location.pathname);
    }

    const response = await fetch(cartAddUrl, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body,
    });
    const result = await response.json();
    if (!response.ok || result.status) throw new Error(result.description || 'Ce produit ne peut pas être ajouté.');

    const cart = await getCart();
    updateCartCount(cart.item_count);
    if (result.sections) {
      document.dispatchEvent(new CartUpdatedEvent(result, {
        itemCount: cart.item_count,
        source: form.dataset.nyQuickAdd !== undefined ? 'nerylux-quick-add' : 'nerylux-product-form',
        sections: result.sections,
      }));
      renderReturnedCartSection(result.sections);
    }
    setFormStatus(form, 'Ajouté au panier.');
    document.dispatchEvent(new CustomEvent(ThemeEvents.cartOpen));
    requestAnimationFrame(() => refreshCartExperience(cart));
  } catch (error) {
    setFormStatus(form, error.message || 'Impossible d’ajouter ce produit.', true);
    document.dispatchEvent(new CustomEvent('toast:open', {
      detail: { type: 'error', message: error.message || 'Impossible d’ajouter ce produit.' },
    }));
  } finally {
    delete form.dataset.nySubmitting;
    if (button) {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      if (form.matches('.ny-product-form')) {
        const label = button.querySelector('[data-atc-label]');
        if (label) label.textContent = originalLabel?.trim() || 'Ajouter au panier';
      }
    }
  }
}

document.addEventListener('submit', (event) => {
  const form = event.target.closest?.('form[data-ny-ajax-cart]');
  if (!form) return;
  event.preventDefault();
  handleAjaxCartSubmit(form);
});

class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.checkoutButton = null;
    this.backdropClickHandler = this.#onBackdropClick.bind(this);
    this.checkoutButtonClickHandler = this.#handleCheckoutButtonClick.bind(this);
    this.cartUpdateHandler = this.#handleCartUpdate.bind(this);
    this.openHandler = this.open.bind(this);
    this.closeHandler = this.close.bind(this);
  }

  connectedCallback() {
    this.checkoutButton = this.querySelector('[data-ref="checkout-button"]');
    this.addEventListener('click', this.backdropClickHandler);
    this.checkoutButton?.addEventListener('click', this.checkoutButtonClickHandler);
    document.addEventListener(ThemeEvents.cartUpdated, this.cartUpdateHandler);
    document.addEventListener(ThemeEvents.cartOpen, this.openHandler);
    document.addEventListener(ThemeEvents.cartClose, this.closeHandler);
    refreshCartExperience();

    if (Shopify.designMode) {
      document.addEventListener('shopify:section:unload', this.#onSectionUnload);
      if (window.theme?.isCartDrawerOpen) {
        this.open();
        window.theme.isCartDrawerOpen = false;
      }
    }
  }

  disconnectedCallback() {
    document.removeEventListener(ThemeEvents.cartClose, this.closeHandler);
    document.removeEventListener(ThemeEvents.cartOpen, this.openHandler);
    document.removeEventListener(ThemeEvents.cartUpdated, this.cartUpdateHandler);
    this.checkoutButton?.removeEventListener('click', this.checkoutButtonClickHandler);
    this.removeEventListener('click', this.backdropClickHandler);
    if (Shopify.designMode) document.removeEventListener('shopify:section:unload', this.#onSectionUnload);
  }

  #onSectionUnload = (event) => {
    if (event.detail.sectionId !== this.dataset.sectionId) return;
    window.theme = window.theme || {};
    window.theme.isCartDrawerOpen = this.isOpen();
  };

  #handleCheckoutButtonClick(event) {
    event.currentTarget.classList.add('is-loading');
  }

  #handleCartUpdate(event) {
    this.renderCartContents(event.detail.data);
  }

  #onBackdropClick(event) {
    const inner = this.querySelector('.cart-drawer__inner');
    if (!inner) return;
    const rect = inner.getBoundingClientRect();
    const isInside = rect.top <= event.clientY && event.clientY <= rect.bottom && rect.left <= event.clientX && event.clientX <= rect.right;
    if (!isInside) this.close();
  }

  open() {
    this.classList.remove('is-closing');
    this.classList.add('is-open');
    document.body.classList.add('overflow-hidden');
    requestAnimationFrame(() => this.querySelector('.cart-drawer__inner')?.focus());
    refreshCartExperience();
  }

  close() {
    this.classList.add('is-closing');
    setTimeout(() => {
      this.classList.remove('is-open', 'is-closing');
      document.body.classList.remove('overflow-hidden');
    }, 125);
  }

  isOpen() {
    return this.classList.contains('is-open');
  }

  renderCartContents(parsedState) {
    const html = parsedState.sections?.[this.dataset.sectionId];
    if (!html) return;
    const newDocument = new DOMParser().parseFromString(html, 'text/html');
    const newInner = newDocument.querySelector('.cart-drawer__inner');
    const currentInner = this.querySelector('.cart-drawer__inner');
    if (!newInner || !currentInner) return;
    currentInner.innerHTML = newInner.innerHTML;
    this.checkoutButton = this.querySelector('[data-ref="checkout-button"]');
    this.checkoutButton?.addEventListener('click', this.checkoutButtonClickHandler);
    this.classList.toggle('cart-drawer--empty', parsedState.itemCount === 0);
    refreshCartExperience();
  }
}

if (!customElements.get('cart-drawer')) customElements.define('cart-drawer', CartDrawer);

class CartDrawerItem extends HTMLElement {
  constructor() {
    super();
    this.removeItemButton = null;
    this.quantitySelectorInput = null;
    this.itemRemoveHandler = this.#handleItemRemove.bind(this);
    this.quantityInputChangeHandler = this.#handleQuantityInputChange.bind(this);
  }

  connectedCallback() {
    this.removeItemButton = this.querySelector('[data-ref="remove-item"]');
    this.quantitySelectorInput = this.querySelector('[data-ref="quantity-selector-input"]');
    this.removeItemButton?.addEventListener('click', this.itemRemoveHandler);
    this.quantitySelectorInput?.addEventListener('change', this.quantityInputChangeHandler);
  }

  disconnectedCallback() {
    this.quantitySelectorInput?.removeEventListener('change', this.quantityInputChangeHandler);
    this.removeItemButton?.removeEventListener('click', this.itemRemoveHandler);
  }

  #handleItemRemove(event) {
    event.preventDefault();
    this.#updateLineItemQuantity(this.dataset.index, 0);
  }

  #handleQuantityInputChange(event) {
    event.preventDefault();
    this.#updateLineItemQuantity(this.dataset.index, this.quantitySelectorInput.value);
  }

  async #updateLineItemQuantity(line, quantity) {
    this.classList.add('cart-drawer__item--loading');
    try {
      const body = JSON.stringify({
        line,
        quantity,
        sections: this.closest('cart-drawer').dataset.sectionId,
        sections_url: window.location.pathname,
      });
      const response = await fetch(`${shopRoot}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body,
      });
      const result = await response.json();
      if (!response.ok || result.errors) {
        const message = Array.isArray(result.errors) ? result.errors.join(', ') : (result.description || 'Impossible de mettre à jour le panier.');
        throw new Error(message);
      }
      document.dispatchEvent(new CartUpdatedEvent(result, {
        itemCount: result.item_count,
        source: 'cart-drawer-item',
        sections: result.sections,
      }));
      refreshCartExperience(result);
    } catch (error) {
      document.dispatchEvent(new CustomEvent('toast:open', { detail: { type: 'error', message: error.message } }));
    } finally {
      this.classList.remove('cart-drawer__item--loading');
    }
  }
}

if (!customElements.get('cart-drawer-item')) customElements.define('cart-drawer-item', CartDrawerItem);

document.addEventListener('DOMContentLoaded', () => refreshCartExperience(), { once: true });
